<template>
  <DialogTemplate style="max-width: calc(100vw - 6rem)">
    <div
      class="d-flex f-wrap"
      style="gap: 1rem"
    >
      <div class="gw_box">
        <div class="text-large weight_700 clr-primary d-flex">
          {{ $t('common.bubble_factor') }}

          <div
            class="mdi mdi-help-circle-outline text-medium ml-2 my-auto clr-grey csst"
            @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'bottom' })"
          >
            <div
              class="csst_content clr-white csst_content_hoverable text-wrap"
              style="position: fixed; line-height: 1.2; max-width: 28rem"
              v-html="
                $t('tooltips.bubble_factor_explained', {
                  linkText: !$i18n.g1
                    ? `<a target='_blank' class='weight_700 link-underline' href='${
                        links_url_links.icm_pressure_guide.url
                      }'>${$t('guides.icm_pressure')}</a>`
                    : $t('guides.icm_pressure'),
                  linkTextBubble: !$i18n.g1
                    ? `<div class='mt-2'><a target='_blank' class='weight_700 link-underline' href='${
                        links_url_links.bubble_factor.url
                      }'>
                      ${$t('guides.bubble_factor_learn_more')}</a></div>`
                    : '',
                })
              "
            ></div>
          </div>
          <GuideTooltip
            placement="right"
            guide="bubble_factor"
            class="my-auto ml-2"
            style="font-size: 0.875rem; --hvr-content-opacity: 1"
          />
        </div>
        <BubbleFactor
          style="border: solid var(--clr-black-0) 1px; border-radius: 4px; overflow: hidden"
          :gameformat
          :solElite
          class="mt-2"
        />
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import GuideTooltip from '@/components/Study/Switchers/GuideTooltip'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import BubbleFactor from '@/components/BubbleFactor/BubbleFactor'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'BubbleFactorsDialog',
  components: {
    BubbleFactor,
    GuideTooltip,
    DialogTemplate,
  },
  mixins: [float_mix, links_mix],
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'payouts-dialog')
    },
  },
  computed: {
    gameformat() {
      return this.$store.getters[SNK('gameformat', this.namespace)]
    },
    solElite() {
      return this.$store.getters[SNK('sol_elite', this.namespace)]
    },
    namespace() {
      return this.dialog.namespace || ''
    },
  },
}
</script>

<style lang="scss" scoped>
// .invite-box {
//   border-radius: 6px;
//   // padding: 0.25rem 1rem;
//   // margin: 0.5rem;
//   font-weight: 500;
//   font-size: 1.25rem;
//   background: var(--clr-black-3);
//   border: solid var(--clr-black-3) 1px;
//   transition: 0.2s;
//   cursor: pointer;
//   &:hover {
//     border: solid var(--clr-primary) 1px;
//     background: var(--clr-primary);
//   }
// }
</style>
